var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-wrapper",attrs:{"id":"scrollWrapper"}},[(_vm.detail)?_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.detail,"frameborder":"0","scrolling":"yes"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }